module.exports = "/_next/static/images/Download-2c27106323dba40ab6a2b4bc4346f399.svg";